import React, { useState, useEffect } from 'react';
import { getInformationWorkOrderLogs, getInformationTraceability } from '../../services/reports/reportServices';
import { getAllNim } from '../../services/notification/notificatiosService.'
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import * as XLSX from 'xlsx';

export const useReportLogs = () => {

    // ? REPORT
    const [dataPatient, setDataPatient] = useState([])
    const [dataReport, setDataReport] = useState([]);
    const [nim, setNim] = useState("");
    const [createSweet] = useSweetAlert();
    const [loadingReport, setLoadingReport] = useState(false);

    // ? TRAZEABILITIY
    const [dataTraceability, setDataTraceability] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const containerStyle = { width: '100%', overflowX: 'auto' };
    const [activeIndex, setActiveIndex] = useState(0);
    const [loadingExcel, setLoadingExcel] = useState(true)
    let enable_tracking_toma = localStorage.getItem('enable_tracking_toma');



    useEffect(() => {
        const initialExpandedRows = dataTraceability.filter(item => item.children && item.children.length > 0);
        setExpandedRows(initialExpandedRows);
    }, [dataTraceability]);


    const handleInputChange = (e) => {
        setNim(e.target.value);
    };


    const handleReport = async () => {
        if (nim === "") {
            createSweet("create", "warning", "Busqueda", "Debe agregar un nim para realizar la busqueda");
            setNim("")
            return;
        }

        const searchNim = await getAllNim(nim);
        if (searchNim.code === 200) {
            if (searchNim.data.length > 0) {
                setLoadingReport(true);
                createSweet("create", "success", "Busqueda", "Datos del paciente cargados correctamente.");
                setActiveIndex(0);

                searchNim.data.forEach(_find => {
                    handleSearch(_find?.id_work_order);
                    if (enable_tracking_toma === 'True') {
                        handleSearchTraceability(_find?.id_work_order);
                    }
                });

                const list = searchNim?.data?.map(_find => {
                    return {
                        admision_date: _find?.admision_date ?? "-----",
                        income_type: _find?.income_type ?? "",
                        name_branch: _find?.name_branch ?? "-----",
                        name_patient: _find?.name_patient ?? "-----",
                        nim: _find?.nim ?? "-----",
                        gender: _find?.id_gender ?? "-----",
                        name_user: _find?.name_user ?? "----",
                        study_delivery: _find?.study_delivery ?? "N/A",
                        company_name: _find?.company_name ?? "",
                        id_status: _find?.id_status ?? 0
                    }
                });
                setDataPatient(list);
            }
            else {
                createSweet("error", "error", "Busqueda", "No se encontraron resultados para este NIM");
                setDataReport([]);
                setDataTraceability([]);
                setDataPatient([]);
                setLoadingReport(false);
                return;
            }
        }
        else {
            createSweet("create", "error", "Busqueda", "No se encontraron resultados");
        }
    }

    const handleSearch = async (_id_work_Order) => {
        const response = await getInformationWorkOrderLogs(_id_work_Order);

        if (response?.code === 200) {

            setLoadingReport(false);
            setNim("");
            setLoadingExcel(false);
            createSweet("create", "success", "Busqueda", "Información general cargada correctamente.");
            setDataReport(response?.data ?? []);
        }
        else {
            createSweet("create", "error", "Busqueda", "No se encontraron resultados");
        }
    }



    const handleSearchTraceability = async (_id_work_Order) => {
        const response = await getInformationTraceability(_id_work_Order);

        if (response?.code === 200) {
            const estudios = [];

            response.data.forEach(item => {
                const profileGroups = {};

                if (Array.isArray(item.traceabilitExams)) {
                    item.traceabilitExams.forEach(exam => {
                        const arrayCurves = (exam?.arrayCurves ?? []).sort((a, b) => a.num_samplings - b.num_samplings);

                        estudios.push({
                            id_exam: exam?.id_exam ?? 0,
                            id_work_order_exam: exam?.id_work_order_exam ?? 0,
                            name: (
                                <label
                                    style={
                                        exam?.check_forwarded
                                            ? { color: "#245075" }
                                            : exam?.is_curve
                                                ? (
                                                    exam?.arrayCurves?.every(curve => !!curve?.user_flebo)
                                                        ? { color: "#51bb25" }
                                                        : { color: "#FF8F00" }
                                                )
                                                : (
                                                    exam?.traceabilitSampling.length === 0
                                                        ? { color: "#FF8F00" }
                                                        : { color: "#51bb25" }
                                                )
                                    }
                                >
                                    {exam?.name ?? "---"}
                                </label>
                            ),
                            refused_check_specimen: exam?.refused_check_specimen ?? "---",
                            check_forwarded: exam?.check_forwarded ?? "---",
                            is_send1: exam?.is_send1 ?? false,
                            is_send2: exam?.is_send2 ?? false,
                            is_toma: exam?.is_toma ?? false,
                            pending: exam?.pending ?? false,
                            traceabilitSampling: exam?.traceabilitSampling ?? [],
                            traceabilitSend: exam?.traceabilitSend ?? [],
                            type: 'exam',
                            is_curve: exam?.is_curve ?? false,
                            arrayCurves: exam?.arrayCurves ?? []
                        });
                    });
                }

                if (Array.isArray(item.traceabilitProfiles)) {
                    item.traceabilitProfiles.forEach(profile => {

                        if (!profileGroups[profile.name_profile]) {
                            profileGroups[profile.name_profile] = [];
                        }

                        let profileNameColor = '';

                        profile.listExam.forEach(_exams => {

                            const examColor = _exams?.check_forwarded ? { color: "#245075" } : _exams?.traceabilitSampling.length === 0 ? { color: '#FF8F00' } : { color: "#51bb25" };

                            if (_exams?.traceabilitSampling.length === 0) {
                                profileNameColor = '#FF8F00';
                            } else if (!_exams?.check_forwarded) {
                                profileNameColor = '#51bb25';
                            } else {
                                profileNameColor = '#245075';
                            }

                            profileGroups[profile.name_profile].push({
                                id_exam: _exams?.id_exam ?? 0,
                                id_work_order_exam: _exams.id_work_order_exam ?? 0,
                                name: <label style={examColor}>{_exams.name ?? "---"}</label>,
                                refused_check_specimen: _exams.refused_check_specimen ?? false,
                                check_forwarded: _exams.check_forwarded ?? false,
                                is_send1: _exams.is_send1 ?? false,
                                is_send2: _exams.is_send2 ?? false,
                                is_toma: _exams.is_toma ?? false,
                                pending: _exams.pending ?? false,
                                traceabilitSampling: _exams.traceabilitSampling ?? [],
                                traceabilitSend: _exams.traceabilitSend ?? [],
                                type: 'exam',
                                profile_name: profile?.name_profile ?? "---"
                            });
                        });

                        estudios.push({
                            type: 'profile',
                            profile_name: <label style={{ color: profileNameColor }}>{profile?.name_profile ?? "---"}</label>,
                            listExm: profileGroups[profile.name_profile]
                        });
                    });
                }
            });
            setDataTraceability(estudios);
            createSweet("create", "success", "Busqueda", "Trazabilidad de la muestra cargada correctamente.");
        }
        else {
            createSweet("create", "error", "Busqueda", "No se encontraron resultados");
            setDataTraceability([]);
        }
    }


    function exportToExcelConTrazabilidad(dataReport, trazabilidadData) {
        const datosPaciente = dataPatient.map((item, index) => ({
            "#": index + 1,
            "Nombre del paciente": item?.name_patient ?? "---",
            "NIM": item?.nim ?? "---",
            "Tipo de ingreso": item?.income_type ?? "---",
            "Compañía": item?.company_name ?? "---",
            "Estado": item?.id_status === 20 ? "Cancelado" : "Vigente",
            "Fecha de ingreso": item?.admision_date ?? "---",
            "Sucursal": item?.name_branch ?? "---",
            "Tiempo de entrega": item?.study_delivery ?? "---",
            "Recepción por": item?.name_user ?? "---"
        }));

        const worksheet1 = XLSX.utils.json_to_sheet(datosPaciente);
        // -------------------------------
        // Hoja 1 - Reporte Auditoría
        // -------------------------------
        let _Report = [];

        if (dataReport.length === 0) {
            _Report.push({
                "#": '',
                Fecha: 'Sin información',
                Usuario: 'Sin información',
                Nombre: 'Sin información',
                Accion: 'Sin información',
            });
        } else {
            dataReport.forEach((_logs, _index) => {
                _Report.push({
                    "#": _index + 1,
                    Fecha: _logs?.created_at ?? '',
                    Usuario: _logs?.user ?? '',
                    Nombre: _logs?.full_name ?? '',
                    Accion: _logs?.action ?? '',
                });
            });

            _Report.push({
                "#": '',
                Fecha: '',
                Usuario: '',
                Nombre: '',
                Accion: "",
            });
        }

        const worksheet3 = XLSX.utils.json_to_sheet(_Report, {
            header: ["#", "Fecha", "Usuario", "Nombre", "Accion"]
        });

        // -------------------------------
        // Hoja 2 - Trazabilidad
        // -------------------------------
        const processedData = trazabilidadData.flatMap(row => {
            const results = [];
            const profileName = row.profile_name?.props?.children || 'Sin Nombre de Perfil';

            if (row.type === 'profile') {
                row.listExm.forEach(exam => {
                    const baseRow = {
                        Estudio: `${profileName} - Examen: ${exam.name?.props?.children || '---'}`,
                        'Toma de muestra': exam.is_toma ? "✅" : "❌",
                        'Fecha Inicio': exam.traceabilitSampling?.[0]?.init_time || "---",
                        Usuario: exam.traceabilitSampling?.[0]?.flebo || "---",
                        Envío: exam.is_send1 ? "✅" : "❌",
                        'Fecha Envio': exam.traceabilitSend?.[exam.traceabilitSend.length - 1]?.init_time_procces2 || "---",
                        'Usuario de Envio': exam.traceabilitSend?.[exam.traceabilitSend.length - 1]?.user_process2 || "---",
                        Recepción: exam.is_send2 ? "✅" : "❌",
                        'Fecha Recepción': exam.traceabilitSend?.[exam.traceabilitSend.length - 1]?.init_time_procces3 || "---",
                        'Usuario Recepción': exam.traceabilitSend?.[exam.traceabilitSend.length - 1]?.user_process3 || "---"
                    };

                    results.push(baseRow);

                    if (exam.is_curve && Array.isArray(exam.arrayCurves)) {
                        exam.arrayCurves.forEach(curve => {
                            results.push({
                                Estudio: `→ Muestreo ${curve.num_samplings}`,
                                'Toma de muestra': "",
                                'Fecha Inicio': "",
                                Usuario: "",
                                Envío: "✔",
                                'Fecha Envio': curve.init_time_procces2 || "---",
                                'Usuario de Envio': curve.user_process2 || "---",
                                Recepción: "✔",
                                'Fecha Recepción': curve.init_time_procces3 || "---",
                                'Usuario Recepción': curve.user_process3 || "---"
                            });
                        });
                    }
                });
            } else {
                const baseRow = {
                    Estudio: row.name?.props?.children || 'Sin Nombre',
                    'Toma de muestra': row.is_curve ? "" : row.is_toma ? "✅" : row.check_forwarded ? "Remitida" : "❌",
                    'Fecha Inicio': row.is_curve ? "" : row.traceabilitSampling?.[0]?.init_time || (row.check_forwarded ? "N/A" : "---"),
                    Usuario: row.is_curve ? "" : row.traceabilitSampling?.[0]?.flebo || "----",
                    Envío: row.is_curve ? "" : row.is_send1 ? "✅" : "❌",
                    'Fecha Envio': row.is_curve ? "" : row.traceabilitSend?.[row.traceabilitSend.length - 1]?.init_time_procces2 || "---",
                    'Usuario de Envio': row.is_curve ? "" : row.traceabilitSend?.[row.traceabilitSend.length - 1]?.user_process2 || "---",
                    Recepción: row.is_curve ? "" : row.is_send2 ? "✅" : "❌",
                    'Fecha Recepción': row.is_curve ? "" : row.traceabilitSend?.[row.traceabilitSend.length - 1]?.init_time_procces3 || "---",
                    'Usuario Recepción': row.is_curve ? "" : row.traceabilitSend?.[row.traceabilitSend.length - 1]?.user_process3 || "---"
                };

                results.push(baseRow);

                if (row.is_curve && Array.isArray(row.arrayCurves)) {
                    row.arrayCurves.forEach(curve => {
                        results.push({
                            Estudio: `- Toma N° ${curve.num_samplings}`,
                            'Toma de muestra': curve.user_flebo !== null ? "✅" : "❌",
                            'Fecha Inicio': curve.init_time_flebo || "---",
                            'Usuario': curve.user_flebo || "---",
                            Envío: curve.user_process2 !== null ? "✅" : "❌",
                            'Fecha Envio': curve.init_time_procces2 || "---",
                            'Usuario de Envio': curve.user_process2 || "---",
                            Recepción: curve.user_process3 !== null ? "✅" : "❌",
                            'Fecha Recepción': curve.init_time_procces3 || "---",
                            'Usuario Recepción': curve.user_process3 || "---"
                        });
                    });
                }
            }

            return results;
        });

        const worksheet2 = XLSX.utils.json_to_sheet(processedData);

        // -------------------------------
        // Crear y exportar archivo Excel
        // -------------------------------
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet1, 'Datos del Paciente');
        XLSX.utils.book_append_sheet(workbook, worksheet2, 'Trazabilidad de la muestra');
        XLSX.utils.book_append_sheet(workbook, worksheet3, 'Información General ');


        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        const fileName = 'Auditoria.xlsx';

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
        } else {
            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
        }
    }


    const [viewCard, setViewCard] = useState(false)

    const handleViewCard = () => {
        setViewCard(!viewCard)
    }

    const handleCloseCard = () => {
        setViewCard(false)
    }









    return {
        dataReport, handleReport, nim, handleInputChange, dataPatient, loadingReport, dataTraceability,
        expandedRows, setExpandedRows, containerStyle, activeIndex, setActiveIndex, exportToExcelConTrazabilidad, loadingExcel,
        handleViewCard, handleCloseCard, viewCard, enable_tracking_toma


    }
}

